import {OBaseAreaViewInit} from "lib/commons/views";
import {IDepotResUiEnv, IDepotShortResUiEnv} from "lib/store/depot";
import {IRegPointer, REG} from "lib/commons/registry";
import {DOMSH} from "lib/commons/xml/domsh";
import {JSX} from "lib/commons/xml/dom";
import {ResBodyView} from "back/store/views/resViewer";


export interface ResInfoView extends ResBodyView {
	initialize(init: OResInfoViewInit): this
}

export interface OResInfoViewInit extends OBaseAreaViewInit<IRegPointer<IDepotResUiEnv | IDepotShortResUiEnv>> {
	/** Lignes constituant cette resInfoView. */
	lines: IResInfosLineDrawer[]

	/** Ecoute les modifs du node (pas de ses voisins ch, anc, hist, succ...). */
	listenChanges?: boolean
}

export class ResInfoView extends ResBodyView {

	lines: IResInfosLineDrawer[];

	protected _initialize(init: OResInfoViewInit) {
		this.reg = init.areaContext.reg;
		super._initialize(init); //init this.area, this.areaContext
		const sr = this.attachShadow(DOMSH.SHADOWDOM_INIT);
		this.reg.installSkin('form-control-areas', sr);
		this._initAndInstallSkin(this.localName, init);

		if (init.listenChanges) (this.reg.env as IDepotResUiEnv).nodeInfosChange?.on("nodeChange", this.refresh.bind(this));
		this.lines = init.lines;
	}

	protected draw() {
		const sr = this.shadowRoot;
		for (let line of this.lines) line.drawLine(this.reg, sr, this);
	}
}

export interface IResInfosLineDrawer {
	drawLine(ctx: IRegPointer<IDepotResUiEnv | IDepotShortResUiEnv>, parent: Node, view: ResBodyView): void
}

REG.reg.registerSkin('store-res-infos', 1, /* language=CSS */ `
	:host {
		display: grid;
		grid-template-columns: auto 1fr;
		grid-gap: .5rem .5rem;
		grid-auto-rows: max-content;
		padding: .5rem;
	}

	/** class 'ctrlLbl' : Compat form-control-areas */
	.line, .ctrlLbl {
		display: contents;
	}

	/** class 'lbl' : Compat form-control-areas */
	.label, .lbl {
		display: flex;
		color: var(--alt1-color);
		justify-content: flex-end;
	}

	/** class 'lbl' : Compat form-control-areas */
	.lbl {
		margin-inline-end: unset;
	}

	.value {
		font-weight: bold;
	}

	.valueEntry {
		display: inline-block;
	}

	:any-link {
		color: unset;
	}
`);

customElements.define('store-res-infos', ResInfoView);